import React from "react";
import { Plane } from "@react-three/drei";
import * as THREE from "three";

function GalacticDust() {
  const texture = new THREE.TextureLoader().load("/textures/dust.png");
  texture.colorSpace = THREE.SRGBColorSpace;

  return (
    <Plane args={[200, 200]} position={[0, 0, -60]} rotation={[Math.PI / 2, 0, 0]}>
      <meshStandardMaterial 
        map={texture}
        opacity={0.05} 
        transparent={true} 
        depthWrite={false} 
      />
    </Plane>
  );
}

export default GalacticDust;